import initialState from './state'
import { set, set_many, set_one, ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST } from '../mutation-mixins'
import * as Types from '../mutation-types'

// noinspection JSUnusedGlobalSymbols
export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    [Types.SET_MANY]: set_many({ to: 'entities' }),
    [Types.SET_ONE]: set_one({ to: 'entities' }),
    [Types.SET_COUNTS]: set({ to: 'counts' }),

    RESET_DRAFT(state) {
        state.draft = initialState().draft
    },

    REPLACE_DRAFT(state, { draft }) {
        state.draft = { ...draft }
    }

}
